import { type ServerRuntimeMetaArgs } from '@remix-run/server-runtime';

import type { loader } from './loader.server';

export const handle = {
  scripts: ({ matches: [_root, dynamicRoute] }: ServerRuntimeMetaArgs<never, { [routeId: string]: typeof loader }>) =>
    dynamicRoute.data.componentScripts,
};
